import { connect } from "react-redux";
import { Drawer } from "antd";
import { getPartnerAccount } from "../../modules/App/AppReducer";
import { useState, useEffect } from "react";

const ProfileHeader = (props) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        window.__openProfileDrawer = () => setDrawerOpen(true);
        return () => { window.__openProfileDrawer = null; };
    }, []);

    const getInitials = () => (props.partneraccount?.contact_name || props.partneraccount?.first_name || '').trim().split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0,2);

    const getFullName = () => {
        if (props.partneraccount?.contact_name) return props.partneraccount.contact_name;
        if (props.partneraccount?.first_name && props.partneraccount?.last_name)
            return `${props.partneraccount.first_name} ${props.partneraccount.last_name}`;
        return '--';
    };

    const isDesktop = props.windowWidth > props.breakpoint;

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/login';
    };

    const profileContent = (
        <div style={{ padding: isDesktop ? '0 20px 20px' : '20px 20px 20px', fontFamily: 'Manrope, sans-serif' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#111827', margin: '0 0 16px 0' }}>
                Basic Details
            </h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                    {[
                        { label: 'Name', value: getFullName() },
                        { label: 'Email', value: props.partneraccount?.contact_email || '--' },
                        { label: 'Ph no', value: props.partneraccount?.contact_phone || '--' },
                        { label: 'Role', value: props.partneraccount?.role || '--' },
                    ].map((row, i) => (
                        <tr key={i}>
                            <td style={{ padding: '10px 0', fontSize: '14px', fontWeight: '600', color: '#374151', width: '80px', verticalAlign: 'top' }}>
                                {row.label}:
                            </td>
                            <td style={{ padding: '10px 0', fontSize: '14px', color: '#6B7280', textTransform: 'capitalize' }}>
                                {row.value}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap');

                .vm-profile-trigger {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 5px 14px 5px 5px;
                    background: #ffffff;
                    border: 1.5px solid #E5E7EB;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
                    height: 42px;
                    font-family: 'Manrope', sans-serif;
                    user-select: none;
                    position: relative;
                }
                .vm-profile-trigger:hover {
                    border-color: #4F6BFF;
                    box-shadow: 0 0 0 3px rgba(79,107,255,0.1);
                }
                .vm-avatar {
                    width: 30px;
                    height: 30px;
                    border-radius: 8px;
                    background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    flex-shrink: 0;
                }
                .vm-profile-name {
                    font-size: 13.5px;
                    font-weight: 600;
                    color: #111827;
                    max-width: 120px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .vm-chevron { color: #9CA3AF; flex-shrink: 0; }

                .vm-profile-dropdown {
                    position: absolute;
                    top: 50px;
                    right: 0;
                    width: 180px;
                    background: #ffffff;
                    border-radius: 12px;
                    box-shadow: 0 12px 30px rgba(0,0,0,0.12);
                    border: 1px solid #E5E7EB;
                    overflow: hidden;
                    z-index: 9999;
                    animation: dropdownFade 0.18s ease;
                }
                .vm-profile-dropdown-item {
                    padding: 12px 14px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #111827;
                    cursor: pointer;
                    transition: background 0.2s ease;
                    font-family: 'Manrope', sans-serif;
                }
                .vm-profile-dropdown-item:hover { background: #F3F4F6; }
                .vm-profile-dropdown-item.logout {
                    color: #EF4444;
                    border-top: 1px solid #F3F4F6;
                }
                @keyframes dropdownFade {
                    from { opacity: 0; transform: translateY(-6px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                /* Mobile Bottom Drawer styling */
                .vm-mobile-profile-drawer .ant-drawer-content-wrapper,
                .vm-mobile-profile-drawer .ant-drawer-content {
                    border-top-left-radius: 24px !important;
                    border-top-right-radius: 24px !important;
                    overflow: hidden !important;
                }
                .vm-mobile-profile-drawer .ant-drawer-body {
                    padding: 24px 20px 32px 20px !important;
                }
                .profile-drawer-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 24px;
                }
                .profile-drawer-title {
                    font-size: 20px;
                    font-weight: 700;
                    color: #111827;
                    font-family: 'Manrope', sans-serif;
                }
                .profile-drawer-close-btn {
                    background: #F3F4F6;
                    border: none;
                    width: 36px;
                    height: 36px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #4B5563;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }
                .profile-drawer-close-btn:hover {
                    background: #E5E7EB;
                    color: #1F2937;
                }
                .profile-drawer-close-btn svg {
                    width: 14px;
                    height: 14px;
                }
                .profile-user-card {
                    background: #F3F4F6;
                    border-radius: 16px;
                    padding: 16px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                }
                .profile-user-avatar {
                    width: 60px;
                    height: 60px;
                    border-radius: 14px;
                    background: linear-gradient(135deg, #FF7E00 0%, #FF2A00 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-size: 22px;
                    font-weight: 700;
                    flex-shrink: 0;
                    font-family: 'Manrope', sans-serif;
                }
                .profile-user-info {
                    display: flex;
                    flex-direction: column;
                }
                .profile-user-name {
                    font-size: 18px;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 2px;
                    font-family: 'Manrope', sans-serif;
                }
                .profile-user-role {
                    font-size: 13.5px;
                    font-weight: 500;
                    color: #8A94A6;
                    font-family: 'Manrope', sans-serif;
                }
                .profile-info-list {
                    display: flex;
                    flex-direction: column;
                }
                .profile-info-row {
                    display: flex;
                    padding: 16px 0;
                    border-bottom: 1.5px solid #F3F4F6;
                    align-items: center;
                }
                .profile-info-row:last-child {
                    border-bottom: none;
                }
                .profile-info-label {
                    width: 90px;
                    color: #8A94A6;
                    font-size: 14px;
                    font-weight: 600;
                    font-family: 'Manrope', sans-serif;
                }
                .profile-info-value {
                    color: #111827;
                    font-size: 14px;
                    font-weight: 700;
                    font-family: 'Manrope', sans-serif;
                }

                /* Desktop Drawer */
                .vm-profile-drawer .ant-drawer-header {
                    padding: 24px 28px 20px;
                    border-bottom: 1px solid #F3F4F6;
                }
                .vm-profile-drawer .ant-drawer-title {
                    font-family: 'Manrope', sans-serif;
                    font-size: 18px;
                    font-weight: 700;
                    color: #111827;
                }
                .vm-profile-drawer .ant-drawer-body {
                    padding: 28px;
                    background: #ffffff;
                }

                @media (max-width: 799px) {
                    .vm-profile-trigger {
                        border: none !important;
                        background: transparent !important;
                        box-shadow: none !important;
                        padding: 0 !important;
                        height: 36px !important;
                        gap: 0 !important;
                    }
                    .vm-profile-trigger .vm-chevron {
                        display: none !important;
                    }
                    .vm-avatar {
                        width: 36px !important;
                        height: 36px !important;
                        border-radius: 8px !important;
                    }
                }
            `}</style>

            <div style={{ position: 'relative' }}>
                {/* Trigger Button */}
                <div className="vm-profile-trigger" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    <div className="vm-avatar">{getInitials()}</div>
                    {isDesktop && <span className="vm-profile-name">{getFullName()}</span>}
                    <svg className="vm-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="6 9 12 15 18 9"/>
                    </svg>
                </div>

                {/* Dropdown */}
                {dropdownOpen && (
                    <div className="vm-profile-dropdown">
                        <div className="vm-profile-dropdown-item" onClick={() => { setDrawerOpen(true); setDropdownOpen(false); }}>
                            View Profile
                        </div>
                        <div className="vm-profile-dropdown-item logout" onClick={handleLogout}>
                            Logout
                        </div>
                    </div>
                )}
            </div>

            {/* DESKTOP — Drawer */}
            {isDesktop && (
                <Drawer
                    placement="right"
                    onClose={() => setDrawerOpen(false)}
                    open={drawerOpen}
                    width="420px"
                    title="Profile"
                    className="vm-profile-drawer"
                    destroyOnClose={false}
                >
                    {profileContent}
                </Drawer>
            )}

            {/* MOBILE — Bottom Drawer sheet */}
            {!isDesktop && (
                <Drawer
                    placement="bottom"
                    onClose={() => setDrawerOpen(false)}
                    open={drawerOpen}
                    height="auto"
                    closable={false}
                    className="vm-mobile-profile-drawer mobile-override-drawer"
                    rootClassName="vm-mobile-profile-drawer mobile-override-drawer"
                    destroyOnClose={false}
                >
                    <div className="profile-drawer-header">
                        <span className="profile-drawer-title">Profile</span>
                        <button className="profile-drawer-close-btn" onClick={() => setDrawerOpen(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <line x1="18" y1="6" x2="6" y2="18"/>
                                <line x1="6" y1="6" x2="18" y2="18"/>
                            </svg>
                        </button>
                    </div>

                    <div className="profile-drawer-content">
                        <div className="profile-user-card">
                            <div className="profile-user-avatar">
                                {getInitials()}
                            </div>
                            <div className="profile-user-info">
                                <span className="profile-user-name">{getFullName()}</span>
                                <span className="profile-user-role">
                                    {props.partneraccount?.role 
                                        ? (props.partneraccount.role.charAt(0).toUpperCase() + props.partneraccount.role.slice(1).toLowerCase()) 
                                        : 'Administrator'}
                                </span>
                            </div>
                        </div>

                        <div className="profile-info-list">
                            <div className="profile-info-row">
                                <span className="profile-info-label">Name:</span>
                                <span className="profile-info-value">{(getFullName() || '--').toLowerCase()}</span>
                            </div>
                            <div className="profile-info-row">
                                <span className="profile-info-label">Email:</span>
                                <span className="profile-info-value" style={{ textTransform: 'none' }}>
                                    {(props.partneraccount?.contact_email || '--').toLowerCase()}
                                </span>
                            </div>
                            <div className="profile-info-row">
                                <span className="profile-info-label">Ph no:</span>
                                <span className="profile-info-value">
                                    {props.partneraccount?.contact_phone || '--'}
                                </span>
                            </div>
                            <div className="profile-info-row">
                                <span className="profile-info-label">Role:</span>
                                <span className="profile-info-value">
                                    {(props.partneraccount?.role || '--').toLowerCase()}
                                </span>
                            </div>
                        </div>
                    </div>
                </Drawer>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    partneraccount: getPartnerAccount(state)
});

export default connect(mapStateToProps)(ProfileHeader);